import React from "react";
import { useNavigate } from "react-router-dom";

export const tickerData = [
  { pair: "BTC/USDT", change: "+1.82%", isUp: true },
  { pair: "SOL/USDT", change: "-0.94%", isUp: false },
  { pair: "BNB/USDT", change: "+3.17%", isUp: true },
  { pair: "XRP/USDT", change: "-1.23%", isUp: false },
  { pair: "DOGE/USDT", change: "+5.21%", isUp: true },
  { pair: "ADA/USDT", change: "+0.68%", isUp: true },
  { pair: "AVAX/USDT", change: "+4.10%", isUp: true },
  { pair: "ETH/USDT", change: "+2.45%", isUp: true },
];

export const LEADERSHIP_TEAM_MEMBERS = [
  { name: "Khaled Mahdi Alateibi", role: "Legal Advisor", imgSrc: "/images/about-img/agce_team_img.png", text: "With over 14 years of experience in corporate law, governance, and regulatory compliance, Khalid is a licensed lawyer and holds a Master's in Public Law. He has held senior leadership and legal positions with organizations including ADNOC, International Golden Group, and the Abu Dhabi Sports Aviation Club, advising on corporate governance, risk management, and strategic legal matters. As Legal Advisor to Arab Global Virtual Assets Services LLC SPC, he provides strategic legal counsel, supporting the company's governance framework, regulatory compliance, and commitment to operating with the highest standards of legal integrity and transparency." },
  { name: "Bhavik Vala", role: "Chief Operating Officer", imgSrc: "/images/about-img/agce_team_img2.png", text: "With over 8 years of experience across digital asset exchanges, blockchain based startups and research institutions, Bhavik has led the design, development and launch of regulated digital asset platforms across multiple jurisdictions. His expertise spans product strategy, trading infrastructure, custody, market structure, regulatory compliance and exchange operations. He holds a Master's degree in Digital Engineering with a specialization in public and private blockchain, combining academic research with practical experience to build secure, scalable and institutional-grade digital asset infrastructure." },
  { name: "Usman Qureshi", role: "Chief business Officer", imgSrc: "/images/about-img/usman-qureshi.jpg", text: "With over 15 years of experience across regulated financial services, fintech, and digital assets, Usman Qureshi has held leadership roles spanning regulatory governance, risk management, technology, and institutional operations. He has founded and led a UAE-regulated digital asset trading business, served as Chief Technology Officer of a Dubai-based cryptocurrency exchange, and built enterprise technology solutions for government and multinational clients. He holds an MBA in Finance from Bahria University, combining financial and operational expertise with practical experience across banking, blockchain, and regulated digital asset markets." },
  // { name: "Sakshi Karnani", role: "Head of Compliance & MLRO", imgSrc: "/images/about-img/agce_team_img6.png", text: "Compliance and regulatory professional with over 10 years of experience in capital markets, AML/CFT, corporate governance, and financial services. Qualified as a Company Secretary (CS), LL.B., ACAMS, and CISI professional, with expertise across regulatory frameworks including SEBI, SCA, DFSA, ADGM, LFSA, and FSC Mauritius." },
  { name: "Nimisha Shukla", role: "Chief Financial Officer", imgSrc: "/images/about-img/agce_team_img4.png", text: "Nimisha Shukla serves as the Finance Manager, bringing over 16 years of extensive experience in accounting, finance, and business operations across the UAE and India. With a strong background in financial management, regulatory compliance, reporting, and operational excellence, she plays a pivotal role in driving the company's financial performance and operational efficiency. Her expertise supports informed decision-making, robust financial controls, and sustainable business growth, contributing significantly to the company's long-term success." },
  { name: "Farhin Shefeek", role: "Internal Auditor", imgSrc: "/images/about-img/agce_team_img5.png", text: "Farhin is an ACCA-qualified finance professional with experience delivering audit, financial reporting, and regulatory solutions across financial services and diverse industry sectors. Having worked with DFSA and FSRA-regulated entities, she has developed expertise in financial governance, internal controls, regulatory compliance, and operational excellence. Her strong understanding of regulated financial environments supports Arab Global's commitment to robust governance, financial integrity, and sustainable growth." },
  { name: "Komal Naz", role: "Risk Officer", imgSrc: "/images/about-img/agce_team_img6.png", text: "With extensive experience across UAE financial markets and multinational institutions, Komal leads Arab Global's enterprise risk and compliance framework. She is certified by the International Compliance Association (ICA) in Conduct Risk and the Chartered Institute for Securities and Investment (CISI) in Risk Management, with additional qualifications in Compliance and Investment Operations. Her expertise spans enterprise risk management, regulatory compliance, governance, and operational risk, ensuring Arab Global maintains institutional-grade risk standards while remaining aligned with the UAE's evolving virtual asset regulatory landscape." },
  { name: "Muhammad Shafiq", role: "IT Security Manager ", imgSrc: "/images/about-img/muhammad-shafiq_img.jpg", text: "Cybersecurity Specialist with over 10 years of experience securing IT infrastructure and managing information security operations in secure FinTech environments. Strong expertise in cybersecurity risk management, network and endpoint security, Identity and Access Management (IAM), security monitoring, incident response, vulnerability management, and Data Loss Prevention (DLP). Proven experience implementing ISO/IEC 27001, PCI DSS, and NIST CSF controls, including governance, risk assessment, policy development, audit readiness, and regulatory compliance. Experienced in Chainalysis KYT for cryptocurrency transaction monitoring, risk detection, wallet screening, and AML-focused investigations, strengthening financial crime prevention and security posture." },
];

export function AboutHeroSection() {
  const navigate = useNavigate();
  return (
    <section className="agc_about_hero">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-12 col-md-12">
            <div className="agc_about_hero_content">
              <h1 className="text-center">
                Built on <span>Trust</span><br />
                Perfected in <span>Service</span>
              </h1>
              <p>
                Trade crypto with confidence on the most secure and reliable exchange.<br />
                Advanced tools, deep liquidity, and unparalleled customer support available 24/7.
              </p>
              <div className="agc_about_hero_btns">
                <button className="agc_btn_gold" onClick={() => navigate('/signup')}>Get Started</button>
                <div className="agc_scan_download_wrapper">
                  <button className="agc_btn_black"><img src="/images/scanbtn.svg" alt="scan" /> Scan to Download</button>
                  <div className="agc_scan_popup">
                    <div className="agc_scan_qr_container">
                      <img src="/images/scan.png" alt="QR Code" />
                    </div>
                    <div className="agc_scan_text">
                      Scan to Download App<br />
                      iOS & Android
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function AboutTickerSection() {
  return (
    <div className="agc_coin_ticker_wrapper">
      <div className="agc_coin_ticker_track">
        {[...tickerData, ...tickerData].map((coin, index) => (
          <div className="agc_ticker_item" key={index}>
            <span className="agc_ticker_pair">{coin.pair}</span>
            <span className={`agc_ticker_change ${coin.isUp ? "agc_up" : "agc_down"}`}>
              {coin.change}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function AboutMarketplaceSection() {
  return (
    <section className="agc_about_marketplace">
      <div className="container">
        <div className="row mb-5">
          <div className="col-lg-6">
            <span className="agc_about_subtitle">ABOUT AGCX</span>
            <h2 className="agc_about_title">A trusted digital asset<br />marketplace</h2>
          </div>
          <div className="col-lg-6 d-flex align-items-center">
            <p className="agc_about_marketplace_text m-0">
              AGCX is a regulated digital asset exchange built for the future of finance.
              Founded in the UAE, we combine institutional-grade technology and
              strong regulatory standards to serve individuals, professional traders, and
              institutions alike.{" "}
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-6 mb-4">
            <div className="agc_mission_card">
              <div className="agc_mission_icon_box">
                <img src="/images/about-img/eye_vision.svg" alt="Vision" />
              </div>
              <div className="agc_mission_content">
                <h3>Vision</h3>
                <p>
                  Connecting the Middle East to global digital asset
                  markets through technology and responsible
                  innovation.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 mb-4">
            <div className="agc_mission_card">
              <div className="agc_mission_icon_box">
                <img src="/images/about-img/mission_icon.svg" alt="Mission" />
              </div>
              <div className="agc_mission_content">
                <h3>Mission</h3>
                <p>
                  Making digital asset trading secure, accessible,
                  and efficient — powered by strong
                  governance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function AboutValuesSection() {
  return (
    <section className="agc_about_values">
      <div className="container">
        <div className="text-center mb-5">
          <span className="agc_about_subtitle text-center d-block">BUILT DIFFERENTLY</span>
          <h2 className="agc_about_title text-center">What we stand for</h2>
        </div>

        <div className="agc_values_grid">
          <div className="agc_value_card">
            <img src="/images/about-img/trust_vector.png" alt="Trust" className="agc_value_img" />
            <h3>Trust first</h3>
            <p>
              Trust is the foundation of everything we do. We prioritize transparency, integrity, and
              security to build lasting relationships with our clients and partners.
            </p>
          </div>
          <div className="agc_value_card agc_value_card_center">
            <h3>Technology driven</h3>
            <p>
              We leverage advanced technology, secure infrastructure, and continuous innovation to deliver scalable,
              efficient, and future-ready digital asset solutions.
            </p>
            <img src="/images/about-img/technology _vector.png" alt="Technology" className="agc_value_img mt-4" />
          </div>
          <div className="agc_value_card">
            <img src="/images/about-img/compliance_vector.png" alt="Compliance" className="agc_value_img" />
            <h3>Compliance by design</h3>
            <p>
              Our platform is built with compliance at its core, ensuring every process aligns
              with regulatory standards, governance frameworks, and industry best practices.
            </p>
          </div>
          <div className="agc_value_card agc_value_card_wide">
            <div className="agc_value_content">
              <h3>Customer focused</h3>
              <p>
                We place our clients at the center of every decision, delivering personalized support, seamless
                experiences, and solutions tailored to their evolving needs.
              </p>
            </div>
            <div className="agc_value_img_wrapper">
              <img src="/images/about-img/customer_vector.png" alt="Customer" className="agc_value_img" />
            </div>
          </div>
          <div className="agc_value_card agc_value_card_wide">
            <div className="agc_value_content">
              <h3>Global mindset</h3>
              <p>
                With an international outlook and local expertise, we create innovative financial solutions that empower clients to
                participate confidently in the global digital asset ecosystem.
              </p>
            </div>
            <div className="agc_value_img_wrapper">
              <img src="/images/about-img/global_vector.png" alt="Global" className="agc_value_img" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function AboutComparisonSection() {
  return (
    <section className="agc_about_comparison">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-5 mb-5">
            <h2 className="agc_about_title mb-4">AGCX Is Built Different, Compared to Other Major Exchanges</h2>
            <p className="agc_about_text_muted">
              Global exchanges serve global markets from offshore. AGCX is built
              specifically for the Middle East — regulated first, not retrofitted.
            </p>
          </div>
          <div className="col-lg-7">
            <div className="agc_comparison_layout">
              <div className="agc_comp_col_left">
                <div className="agc_comp_card active_gold">
                  <div className="agc_comp_icon_wrapper">
                    <img src="/images/about-img/regulated_vector.svg" alt="Regulated" />
                  </div>
                  <h4>Regulated by design</h4>
                  <p>Licensed under regional regulatory frameworks from day one, not offshore and unregulated.</p>
                </div>

                <div className="agc_comp_card active_gold">
                  <div className="agc_comp_icon_wrapper">
                    <img src="/images/about-img/client_funds_vector.svg" alt="Segregated client funds" />
                  </div>
                  <h4>Segregated client
                    funds</h4>
                  <p>Client assets held in segregated custody accounts, separate from corporate operating funds.</p>
                </div>

              </div>


              <div className="agc_comp_col_right">
                <div className="agc_comp_card">
                  <div className="agc_comp_icon_wrapper light_icon">
                    <img
                      src="/images/about-img/local_vector.svg"
                      alt="Local fiat"

                    />
                  </div>
                  <h4>Local fiat rails</h4>
                  <p>Direct AED and regional settlement, without offshore banking workarounds.</p>
                </div>
                <div className="agc_comp_card">
                  <div className="agc_comp_icon_wrapper light_icon">
                    <img
                      src="/images/about-img/support_vector.svg"
                      alt="support"

                    />
                  </div>
                  <h4>Regional support</h4>
                  <p>Onshore team and jurisdiction-specific onboarding, not a generic global playbook.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function AboutOversightSection({ openProfileModal }) {
  return (
    <section className="agc_about_oversight">
      <div className="container">
        <div className="text-center mb-5">
          <div className="agc_section_header_line">
            <span>OUR LEADERSHIP TEAM</span>
          </div>
          <h2 className="agc_about_title">Experienced oversight</h2>
        </div>

        <div className="row mb-4">
          <div className="col-lg-6 mb-4">
            <div className="agc_oversight_card">
              <div className="agc_oversight_img_wrapper">
                <img src="/images/about-img/sheikh_mohammed.jpg" alt="Highness Sheikh Mohammed Khalifa Sultan Shakhbout Al Nahyan" className="agc_oversight_img" />
              </div>
              <div className="agc_oversight_info">
                <h3>Highness Sheikh Mohammed Khalifa Sultan Shakhbout Al Nahyan</h3>
                <span className="agc_role">Non-Executive Director</span>
                <div className="agc_profile_desc_clamp">
                  <p>
                    Highness Sheikh Mohammed Khalifa Sultan Shakhbout Al Nahyan (Member of the ruler family of UAE) is a distinguished Emirati leader, investor, and entrepreneur who brings strategic vision and long-term leadership to Arab Global Virtual Assets Services LLC. With broad interests spanning strategic investments, technology, infrastructure, real estate, and innovation, he has consistently championed initiatives that support the UAE&apos;s economic diversification and position the country as a global hub for future industries. His leadership reflects a strong commitment to sustainable growth, responsible governance, and fostering partnerships that create lasting value.
                  </p>
                  <p>
                    As non-executive Director of Arab Global Virtual Assets Services LLC SPC, Sheikh Mohammed provides strategic oversight and guidance, supporting the company&apos;s mission to build a trusted, secure, and institutionally focused virtual asset platform. His vision reinforces Arab Global&apos;s commitment to regulatory excellence, technological innovation, robust governance, and responsible participation in the evolving digital asset ecosystem. Under his leadership, the company is well positioned to contribute to the UAE&apos;s ambition of becoming a leading global centre for digital assets and financial innovation.
                  </p>
                </div>
                <button
                  className="agc_btn_solid_gold mt-auto"
                  onClick={() =>
                    openProfileModal({
                      name: "Highness Sheikh Mohammed Khalifa Sultan Shakhbout Al Nahyan",
                      role: "Non - Executive Director",
                      image: "/images/about-img/sheikh_mohammed.jpg",
                      description:
                        "Highness Sheikh Mohammed Khalifa Sultan Shakhbout Al Nahyan (Member of the ruler family of UAE) is a distinguished Emirati leader, investor, and entrepreneur who brings strategic vision and long-term leadership to Arab Global Virtual Assets Services LLC. With broad interests spanning strategic investments, technology, infrastructure, real estate, and innovation, he has consistently championed initiatives that support the UAE's economic diversification and position the country as a global hub for future industries. His leadership reflects a strong commitment to sustainable growth, responsible governance, and fostering partnerships that create lasting value.\n\nAs non-executive Director of Arab Global Virtual Assets Services LLC SPC, Sheikh Mohammed provides strategic oversight and guidance, supporting the company's mission to build a trusted, secure, and institutionally focused virtual asset platform. His vision reinforces Arab Global's commitment to regulatory excellence, technological innovation, robust governance, and responsible participation in the evolving digital asset ecosystem. Under his leadership, the company is well positioned to contribute to the UAE's ambition of becoming a leading global centre for digital assets and financial innovation.",
                    })
                  }
                >
                  View Full Profile &rarr;
                </button>
              </div>
            </div>
          </div>
          <div className="col-lg-6 mb-4">
            <div className="agc_oversight_card">
              <div className="agc_oversight_img_wrapper">
                <img src="/images/about-img/ai_khoori_director_img.jpg" alt="Vice Chairman" className="agc_oversight_img" />
              </div>
              <div className="agc_oversight_info">
                <h3>Ibraheem Al Khoori</h3>
                <span className="agc_role">Non-Executive Director</span>
                <div className="agc_profile_desc_clamp">
                  <p>
                    With extensive leadership experience across the UAE&apos;s energy and maritime sectors, Ibraheem Al Khoori brings deep expertise in operational management, regulatory compliance, risk management, and strategic planning. Having spent nearly a decade with Abu Dhabi National Oil Company (ADNOC), he has led complex operations in highly regulated environments, building a strong track record of operational excellence and stakeholder engagement.
                  </p>
                  <p>
                    As Executive Director of Arab Global Virtual Assets Services LLC, Ibraheem provides strategic oversight that strengthens the company&apos;s governance, operational resilience, and commitment to delivering secure, compliant, and institutional-grade digital asset services.
                  </p>
                </div>

                <button
                  className="agc_btn_solid_gold mt-auto"
                  onClick={() =>
                    openProfileModal({
                      name: "Ibraheem Al Khoori",
                      role: "Non - Executive Director",
                      image: "/images/about-img/ai_khoori_director_img.jpg",
                      description:
                        "With extensive leadership experience across the UAE's energy and maritime sectors, Ibraheem Al Khoori brings deep expertise in operational management, regulatory compliance, risk management, and strategic planning. Having spent nearly a decade with Abu Dhabi National Oil Company (ADNOC), he has led complex operations in highly regulated environments, building a strong track record of operational excellence and stakeholder engagement.\n\nAs Executive Director of Arab Global Virtual Assets Services LLC, Ibraheem provides strategic oversight that strengthens the company's governance, operational resilience, and commitment to delivering secure, compliant, and institutional-grade digital asset services.",
                    })
                  }
                >
                  View Full Profile &rarr;
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function AboutSatishSection({ openProfileModal }) {
  return (
    <section className="agc_about_exec_directors pb-5">
      <div className="container">
        <div className="text-center mb-5">
          <div className="agc_section_header_line">
            <span>EXECUTIVE DIRECTORS</span>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="agc_oversight_card agc_large_card">
              <div className="agc_oversight_img_wrapper_large">
                <img
                  src="/images/about-img/sartish_gogia_img.jpg"
                  alt="Director"
                  className="agc_oversight_img_large"
                />
              </div>

              <div className="agc_oversight_info ms-2">
                <h3>Mr Satish Gogia</h3>
                <span className="agc_role">Director & Senior Executive Officer</span>

                <div className="agc_profile_desc_clamp_15">
                  <p>
                    With nearly four decades of experience across capital markets, commodities, financial services, and financial technology, Satish Gogia is a pioneering entrepreneur and Chartered Accountant who has consistently driven innovation in regulated financial markets across India and the UAE. A Chartered Accountant since 1987, he founded Gogia Capital Services Ltd., which grew into a Bombay Stock Exchange-listed financial services company and became a SEBI-regulated merchant banker, trading and clearing member, and one of the early adopters of electronic securities trading in India. Throughout his career, he has led several industry-first initiatives, including online trading, online depository services, mobile trading, algorithmic trading, and market-making solutions. In 2005, he established ARAB Global Commodities DMCC in Dubai, building one of the leading market-making businesses on the Dubai Gold & Commodities Exchange (DGCX), while expanding his expertise across securities, derivatives, commodities, and institutional trading infrastructure.
                  </p>

                  <p>
                    As Founder and Director of Arab Global Virtual Assets Services LLC, Satish provides the strategic vision behind the firm&apos;s institutional approach to digital assets. Drawing on decades of experience in regulated financial markets, exchange operations, and financial innovation, he is leading the development of a secure, technology-driven, and compliant virtual asset ecosystem that upholds the highest standards of governance, risk management, and client service, positioning Arab Global as a trusted partner for institutional and professional investors.
                  </p>
                </div>
                <button
                  className="agc_btn_solid_gold mt-4"
                  onClick={() =>
                    openProfileModal({
                      name: "Mr Satish Gogia",
                      role: "Director & Senior Executive Officer",
                      image: "/images/about-img/sartish_gogia_img.jpg",
                      description:
                        "With nearly four decades of experience across capital markets, commodities, financial services, and financial technology, Satish Gogia is a pioneering entrepreneur and Chartered Accountant who has consistently driven innovation in regulated financial markets across India and the UAE. A Chartered Accountant since 1987, he founded Gogia Capital Services Ltd., which grew into a Bombay Stock Exchange-listed financial services company and became a SEBI-regulated merchant banker, trading and clearing member, and one of the early adopters of electronic securities trading in India. Throughout his career, he has led several industry-first initiatives, including online trading, online depository services, mobile trading, algorithmic trading, and market-making solutions. In 2005, he established ARAB Global Commodities DMCC in Dubai, building one of the leading market-making businesses on the Dubai Gold & Commodities Exchange (DGCX), while expanding his expertise across securities, derivatives, commodities, and institutional trading infrastructure.\n\nAs Founder and Director of Arab Global Virtual Assets Services LLC, Satish provides the strategic vision behind the firm's institutional approach to digital assets. Drawing on decades of experience in regulated financial markets, exchange operations, and financial innovation, he is leading the development of a secure, technology-driven, and compliant virtual asset ecosystem that upholds the highest standards of governance, risk management, and client service, positioning Arab Global as a trusted partner for institutional and professional investors.",
                    })
                  }
                >
                  View Full Profile &rarr;
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function AboutLeadershipTeamSection({ openProfileModal }) {
  return (
    <section className="agc_about_team">
      <div className="container">
        <div className="text-center mb-5">
          <div className="agc_section_header_line">
            <span>LEADERSHIP TEAM</span>
          </div>
        </div>

        <div className="row">
          {LEADERSHIP_TEAM_MEMBERS.map((item, idx) => (
            <div className="col-lg-4 col-md-6 mb-4" key={item.name}>
              <div className="agc_team_card">
                <div className="agc_team_header">
                  <img
                    src={item.imgSrc || `/images/about-img/agce_team_img${idx === 0 ? "" : idx + 1}.png`}
                    alt={item.name}
                    className="agc_team_img"
                  />
                </div>
                <div className="agc_team_name_role">
                  <h4>{item.name}</h4>
                  <span>{item.role}</span>
                </div>
                <div className="agc_team_info mt-3 agc_profile_desc_clamp_4">
                  <p>{item.text}</p>
                </div>
                <span
                  className="agc_btn_link_gold mt-auto"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    openProfileModal({
                      name: item.name,
                      role: item.role,
                      image: item.imgSrc || `/images/about-img/agce_team_img${idx === 0 ? "" : idx + 1}.png`,
                      description: item.text,
                      isLeadership: true,
                    })
                  }
                >
                  VIEW FULL PROFILE &rarr;
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function AboutLicenseSection() {
  const [showLicenseModal, setShowLicenseModal] = React.useState(false);

  React.useEffect(() => {
    if (showLicenseModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [showLicenseModal]);

  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setShowLicenseModal(false);
      }
    };
    if (showLicenseModal) {
      window.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [showLicenseModal]);

  return (
    <section className="agc_about_license">
      <div className="agc_blur_blue_left_small"></div>
      <div className="container">
        <h2 className="agc_about_title mb-5">
          <span className="agc_licensed_underline">Licensed in the UAE</span>
        </h2>

        <div className="agc_license_card mb-5">
          <div className="agc_license_left">
            <div className="agc_license_icon_outer">
              <div className="agc_license_icon_inner">
                <img src="/images/about-img/shield_icon.svg" alt="Shield" />
              </div>
            </div>
            <div className="agc_license_text">
              <h4>Virtual Asset Multilateral Trading Facility</h4>
              <p className="mb-0">
                Operated in the UAE through ARAB GLOBAL VIRTUAL ASSETS SERVICES &ndash; L.L.C &ndash; S.P.C, headquartered in Abu Dhabi.
              </p>
            </div>
          </div>
          <div className="agc_license_right">
            <button
              className="agc_btn_solid_gold_license"
              onMouseEnter={() => setShowLicenseModal(true)}
              onClick={() => setShowLicenseModal(true)}
            >
              {/* <i className="fa fa-external-link me-2" style={{ fontSize: "14px" }}></i> VA MTF &bull; Abu Dhabi */}
              <img src="/images/about-img/license_certificate_img.jpg" alt="license" />
            </button>
          </div>
        </div>


      </div>


      <div className="agc_company_info_section information_section mt-5">
        <div className="company_info_after">
          <img src="/images/about-img/informationcnt_after.png" alt="Legal Entity" />
        </div>
        <div className="container">
          <h6 className="agc_company_info_subtitle mb-4"><span>COMPANY</span> INFORMATION</h6>

          <div className="row">


            <div className="col-lg-4">
              <div className="agc_company_info_card">
                <div className="agc_company_info_header mb-4">
                  <div className="about_icon_after">
                    <img src="/images/about-img/about_buble_effect.png" alt="buble effect" />
                  </div>

                  <div className="agc_company_info_icon">
                    <img src="/images/about-img/legal_entity_img.svg" alt="Legal Entity" />
                  </div>
                  <div className="about_information_cnt">
                    <h4>Legal Entity</h4>
                    <p>Arab Global Virtual
                      Assets Services –
                      L.L.C – S.P.C</p>
                  </div>
                </div>

                <div className="border_bottom_after">
                  <img src="/images/about-img/about_after_bottom.png" alt="buble effect" />
                </div>

              </div>
            </div>


            <div className="col-lg-4">
              <div className="agc_company_info_card">
                <div className="agc_company_info_header mb-4">
                  <div className="about_icon_after">
                    <img src="/images/about-img/about_buble_effect.png" alt="buble effect" />
                  </div>

                  <div className="agc_company_info_icon">
                    <img src="/images/about-img/about_location.svg" alt="Legal Entity" />
                  </div>
                  <div className="about_information_cnt">
                    <h4>Head Office</h4>
                    <p>Office 1603, Tower C,Electra Road, Abu Dhabi</p>
                  </div>
                </div>

                <div className="border_bottom_after">
                  <img src="/images/about-img/about_after_bottom.png" alt="buble effect" />
                </div>

              </div>
            </div>



            <div className="col-lg-4">
              <div className="agc_company_info_card">
                <div className="agc_company_info_header mb-4">
                  <div className="about_icon_after">
                    <img src="/images/about-img/about_buble_effect.png" alt="buble effect" />
                  </div>

                  <div className="agc_company_info_icon">
                    <img src="/images/about-img/email_cont_img.svg" alt="Legal Entity" />
                  </div>
                  <div className="about_information_cnt">
                    <h4>Contact</h4>
                    <p>contactus@arabglobal.ae</p>
                    <p>+971 2 546 8911</p>
                  </div>
                </div>

                <div className="border_bottom_after">
                  <img src="/images/about-img/about_after_bottom.png" alt="buble effect" />
                </div>

              </div>
            </div>



            {/* <div className="col-lg-4 mb-4">
              <div className="agc_company_info_card">
                <div className="agc_company_info_header mb-4">
                  <div className="agc_company_info_icon">
                    <img src="/images/about-img/legal_entity_img.svg" alt="Legal Entity" />
                  </div>
                  <h4 className="mb-0 ms-3">Legal Entity</h4>
                </div>

                <div className="agc_company_info_row">
                  <span className="agc_company_info_label">Entity</span>
                  <span className="agc_company_info_value">ARAB GLOBAL VIRTUAL ASSETS SERVICES &ndash; L.L.C &ndash; S.P.C</span>
                </div>
                <div className="agc_company_info_row">
                  <span className="agc_company_info_label">Activity</span>
                  <span className="agc_company_info_value">Virtual Asset MTF</span>
                </div>
                <div className="agc_company_info_row">
                  <span className="agc_company_info_label">Head office</span>
                  <span className="agc_company_info_value">Commercial Tower C, Electra Road, Abu Dhabi</span>
                </div>
                <div className="agc_company_info_row">
                  <span className="agc_company_info_label">P.O. Box</span>
                  <span className="agc_company_info_value">45526</span>
                </div>
              </div>
            </div> */}

            {/* <div className="col-lg-4 mb-4">
              <div className="agc_company_info_card">
                <div className="agc_company_info_header mb-4">
                  <div className="agc_company_info_icon">
                    <img src="/images/about-img/email_cont_img.svg" alt="Contact" />
                  </div>
                  <h4 className="mb-0 ms-3">Contact</h4>
                </div>

                <div className="agc_company_info_row">
                  <span className="agc_company_info_label">Email</span>
                  <span className="agc_company_info_value">contactus@arabglobal.ae</span>
                </div>
                <div className="agc_company_info_row">
                  <span className="agc_company_info_label">Phone</span>
                  <span className="agc_company_info_value">+971 2 546 8911</span>
                </div>
                <div className="agc_company_info_row">
                  <span className="agc_company_info_label">Office</span>
                  <span className="agc_company_info_value">Office No. 1603, Tower C</span>
                </div>
                <div className="agc_company_info_row">
                  <span className="agc_company_info_label">Location</span>
                  <span className="agc_company_info_value">Abu Dhabi, UAE</span>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>


      <div
        className={`agc_modal_overlay ${showLicenseModal ? 'active' : ''}`}
        onClick={() => setShowLicenseModal(false)}
      >
        <div className="agc_modal_container" onClick={(e) => e.stopPropagation()}>
          <button
            className="agc_modal_close_btn absolute_close"
            onClick={() => setShowLicenseModal(false)}
            aria-label="Close modal"
          >
            &times;
          </button>
          <div className="agc_modal_body full_body">
            <iframe
              src="/images/about-img/license_certificate.pdf#toolbar=0&view=FitH"
              title="License Certificate"
              className="agc_pdf_iframe"
              scrolling="no"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export function AboutCtaSection() {
  const navigate = useNavigate();
  return (
    <section className="agc_about_cta mb-5 pb-5">
      <div className="container">
        <div className="agc_cta_banner p-5 d-flex align-items-center justify-content-between position-relative">
          <div className="agc_cta_bg_shapes"></div>
          <div className="text-white agc_cta_content ps-4 py-4">
            <h2 className="mb-3 fw-bold">Ready to get started?</h2>
            <p className="mb-4" style={{ color: "#ffffffff", lineHeight: "1.6" }}>
              Speak with our team about individual, professional,<br />
              or institutional access.
            </p>
            <div className="d-flex gap-3 mt-4">
              <button onClick={() => navigate('/signup')} className="btn btn-light text-dark rounded-pill d-flex align-items-center fw-bold">
                Get started <span className="ms-2">&rarr;</span>
              </button>
              <button onClick={() => navigate('/contact')} className="btn btn-outline-light rounded-pill fw-bold">Contact us</button>
            </div>
          </div>
          <div className="agc_cta_img_placeholder">
            <img src="/images/about-img/get_token_img.png" alt="Get Token" className="agc_cta_chest_img" />
          </div>
        </div>
      </div>
    </section>
  );
}
